
export default str => str.split(' ').join('');
